import React, { useState, useEffect, useContext, useCallback } from "react";
import Content from "../../components/SatCourse/Content";
import { bookmarkTopic, deleteBookmarkTopic, getSatCourses, getChapters, unlockAndGetNextTopic } from "../../services/SatCourseService";
// @ts-ignore
import ApiNames from "../../constants/ApiNames";
import { useLocation, useNavigate } from "react-router-dom";
// @ts-ignore
import UserContext from "../../utils/UserContext";

export interface ContentScreenProps {
  token?: string;
  moduleIndex?: number;
}

const ContentScreen: React.FC<ContentScreenProps> = (props) => {
  const {
    subscriberId,
    setCheckSatNavbar,
    setSatCourseData,
    setSatChapters,
    checkRefresh,
    setActiveIndex,
    activeIndex,
    satChapters,
  } = useContext<any>(UserContext);
  
  const useLocations = useLocation();
  const listdata = useLocations.state?.listData || [];
  const arrayCurrentIndex = useLocations.state?.index || 0;
  const chaptersCurrentIndex = useLocations.state?.chaptersCurrentIndex || 0;
  const moduleId = useLocations.state?.moduleId || "";
  const moduleIndex = useLocations.state?.moduleIndex || 0;
  const courseTitle = useLocations.state?.courseTitle || "";
  const chapterTitle = useLocations.state?.chapterTitle || "";
  const chapterName = useLocations.state?.chapterTitle || "";

  const [noOfPages, setNumPages] = useState<number[]>([]);
  const [isError] = useState<boolean>(false);
  const [innerWidth, setInnerWidth] = useState<number>(window.innerWidth);
  const [isNavigateBookmark, setIsNavigateBookmark] = useState<boolean>(false);
  const [data, setData] = useState<any[]>(listdata);
  const [currentIndex, setCurrentIndex] = useState<number>(arrayCurrentIndex);
  const [checkPrevious, setCheckPrevious] = useState<boolean>(false);
  const [checkBottom, setCheckBottom] = useState<boolean>(true);
  const [chapterCompleted, setChapterCompleted] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (useLocations.state?.checkBookMarkScreen) {
      if (!checkRefresh) {
        setActiveIndex(useLocations.state.moduleIndexbookMark);
      } else if (activeIndex !== useLocations.state.moduleIndexbookMark) {
        setActiveIndex(useLocations.state.moduleIndexbookMark);
      }
      setIsNavigateBookmark(true);
    } else {
      setIsNavigateBookmark(false);
      if (!checkRefresh) {
        setActiveIndex(moduleIndex);
      } else if (activeIndex !== props?.moduleIndex) {
        setActiveIndex(moduleIndex);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setInnerWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onDocumentLoadSuccess = useCallback((numOfPages: number) => {
    const numArray: number[] = [];
    for (let i = 1; i <= numOfPages; i++) {
      numArray.push(i);
    }
    setNumPages(numArray);
  }, []);

  const HandleBookMark = useCallback(async (id: string | number) => {
    const apiData = {
      subscriberId: subscriberId,
      topicId: id,
    };
    try {
      const response = await bookmarkTopic(apiData, props.token);
      if (response && response.status === 200) {
        const newData = [...data];
        newData[currentIndex] = { ...newData[currentIndex], isBookmarked: !newData[currentIndex].isBookmarked };
        setData(newData);
      } else {
        console.log("Response", response?.status);
      }
    } catch (error) {
      console.log(error);
    }
  }, [currentIndex, data, props.token, subscriberId]);

  const HandleDeleteBookMark = useCallback(async (id: string | number) => {
    const apiData = {
      subscriberId: subscriberId,
      topicId: id,
    };
    try {
      const response = await deleteBookmarkTopic(apiData, props.token);

      if (response && response.status === 200) {
        const newData = [...data];
        newData[currentIndex] = { ...newData[currentIndex], isBookmarked: !newData[currentIndex].isBookmarked };
        setData(newData);
      }
    } catch (error) {
      console.log(error);
    }
  }, [currentIndex, data, props.token, subscriberId]);

  const HandleNavigate = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const HandlePreviousPdf = useCallback(() => {
    if (currentIndex === 1) {
      setCurrentIndex(currentIndex - 1);
      setCheckPrevious(true);
    } else {
      setCurrentIndex(currentIndex - 1);
    }
  }, [currentIndex]);

  const HandleNextpdf = useCallback((id: string | number) => {
    if (!checkBottom) {
      setCheckBottom(true);
    }
    if (data.length - 1 !== currentIndex) {
      setCurrentIndex(currentIndex + 1);
      setCheckPrevious(false);
    }
  }, [checkBottom, currentIndex, data.length]);

  const CoursesApiCall = useCallback(async () => {
    try {
      const response = await getSatCourses(subscriberId, props.token);
      if (response && response.status === 200) {
        setSatCourseData(response.response);
      } else {
        console.log("Response", response?.status);
      }
    } catch (error) {
      console.log("Fail to load ", error);
    }
  }, [setSatCourseData, subscriberId, props.token]);

  const chaptersApiCall = useCallback(async () => {
    try {
      const response = await getChapters(moduleId, subscriberId, props.token);
      if (response && response.status === 200) {
        setSatChapters(response.response);
      } else {
        console.log("Response", response?.status);
      }
    } catch (error) {
      console.log(error);
    }
  }, [moduleId, setSatChapters, subscriberId, props.token]);

  const nextPdfAPiCALL = useCallback(async (id: string | number) => {
    setCheckBottom(false);
    const apiData = {
      subscriberId: subscriberId,
      topicId: id,
    };
    try {
      const response = await unlockAndGetNextTopic(apiData, props.token);

      if (response && response.status === 200) {
        if (currentIndex === data.length - 1) {
          CoursesApiCall();
          chaptersApiCall();
        } else {
          const newData = [...data];
          newData[currentIndex + 1] = response.response;
          setData(newData);
          CoursesApiCall();
          chaptersApiCall();
        }
      } else {
        console.log("Response ", response?.status);
      }
    } catch (error) {
      console.log(error);
    }
  }, [CoursesApiCall, chaptersApiCall, currentIndex, data, props.token, subscriberId]);


  const handleScroll = useCallback((e: any) => {
    const diff = e.target.scrollHeight - e.target.scrollTop;
    const bottom = diff - 10 <= e.target.clientHeight;

    if (bottom === true) {
      if (data.length - 1 === currentIndex) {
        if (!isNavigateBookmark) {
          if (checkBottom) {
            if (satChapters && satChapters[chaptersCurrentIndex]?.progressPercent < 100) {
              const id = data[currentIndex]?.id;
              nextPdfAPiCALL(id);
            }
            if (satChapters && chaptersCurrentIndex !== satChapters.length - 1) {
              setChapterCompleted(true);
            }
          }
        }
      } else {
        if (data[currentIndex + 1]?.lockStatus) {
          if (checkBottom) {
            const id = data[currentIndex].id;
            nextPdfAPiCALL(id);
          }
        }
      }
    }
  }, [chaptersCurrentIndex, checkBottom, currentIndex, data, isNavigateBookmark, nextPdfAPiCALL, satChapters]);

  const downloadFile = useCallback((url: string) => {
    fetch(`${url}`).then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        const alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = `${data[currentIndex].title}`;
        alink.click();
      });
    });
  }, [currentIndex, data]);

  const HandleSatNavBarResp = useCallback(() => {
    setCheckSatNavbar(true);
  }, [setCheckSatNavbar]);

  return (
    <Content
      isError={isError}
      innerWidth={innerWidth}
      HandleBookMark={HandleBookMark}
      HandleDeleteBookMark={HandleDeleteBookMark}
      data={data}
      HandleNavigate={HandleNavigate}
      chapterName={chapterName}
      isNavigateBookmark={isNavigateBookmark}
      onDocumentLoadSuccess={onDocumentLoadSuccess}
      noOfPages={noOfPages}
      HandleNextpdf={HandleNextpdf}
      HandlePreviousPdf={HandlePreviousPdf}
      handleScroll={handleScroll}
      currentIndex={currentIndex}
      checkPrevious={checkPrevious}
      downloadFile={downloadFile}
      courseTitle={courseTitle}
      HandleSatNavBarResp={HandleSatNavBarResp}
      chaptersCurrentIndex={chaptersCurrentIndex}
      chapterTitle={chapterTitle}
      chapterCompleted={chapterCompleted}
    />
  );
};
export default ContentScreen;
